export const ScopedType = (scope) => (action) => `${scope}/${action}`;

export const ScopedAsyncType = (scope) => (action) => ({
  start: `${scope}/${action}_START`,
  complete: `${scope}/${action}_COMPLETE`,
  failure: `${scope}/${action}_FAILURE`,
});
